import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex h-11 items-center" }
const _hoisted_2 = { class: "h-full w-full" }
const _hoisted_3 = { class: "ml-auto flex shrink-0 items-center gap-2.5" }
const _hoisted_4 = {
  key: 2,
  class: "pr-2.5 text-sm"
}

import { SidebarTrigger } from '@/components/ui/sidebar';
    import { useSidebar } from '@/components/ui/sidebar';
    import Card from './ui/card/Card.vue';
    import { computed, ref } from 'vue';
    import AppCustomerSelector from '@/components/AppCustomerSelector.vue';
    import GlobalSearch from '@/components/GlobalSearch.vue';
    import { usePage } from '@inertiajs/vue3';
    import { type SharedData } from '@/types';
    import OnboardingGuide from '@/components/onboarding/OnboardingGuide.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  setup(__props) {

    const page = usePage<SharedData>();
    const hasMultipleCompanies = computed(() => page.props.auth.has_multiple_companies);
    const isClient = computed(() => page.props.auth.user.is_client);
    const isOnboarded = computed(() => page.props.auth.user.is_onboarded);
    const onboardingSteps = computed(() => page.props.auth.onboarding_steps);
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const onboardingGuideRef = ref<InstanceType<typeof OnboardingGuide> | null>(null);
    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "rounded-none border-none px-2" }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createVNode(_unref(SidebarTrigger)),
        _createElementVNode("div", _hoisted_2, [
          (_unref(hasPermission)(_unref(Permission).GLOBAL_SEARCH_SEARCH))
            ? (_openBlock(), _createBlock(GlobalSearch, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (
                        ((isClient.value && !isOnboarded.value) || onboardingGuideRef.value?.assistantOpen) &&
                        _unref(hasPermission)(_unref(Permission).ONBOARDING_UPDATE_STATUS)
                    )
            ? (_openBlock(), _createBlock(OnboardingGuide, {
                key: 0,
                ref_key: "onboardingGuideRef",
                ref: onboardingGuideRef,
                "onboarding-steps": onboardingSteps.value,
                "company-id": selectedCompanyId.value
              }, null, 8, ["onboarding-steps", "company-id"]))
            : _createCommentVNode("", true),
          (!isClient.value || hasMultipleCompanies.value)
            ? (_openBlock(), _createBlock(AppCustomerSelector, { key: 1 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(page).props.auth.user.selected_company_name), 1))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})